export default __webpack_public_path__ + "static/SR USA - Kosher (en inglés) - Certificado-ced04dc26c1b7b306f4b23ed9c6103a5.pdf";